var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"svg-icon",style:(_vm.customStyle || _vm.iconStyle),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.iconClass}})])
}
var staticRenderFns = []

export { render, staticRenderFns }